import { Property } from "js/components/types";

import { AxiosInstance } from "../utils/AxiosInstance";

export const createProperty = async (newProperty: Property) => {
  const payload: any = {
    address: newProperty.address,
    alias: newProperty.alias,
    rental_price: newProperty.rental_price,
    maintenance_price: newProperty.maintenance_price,
    usage: newProperty.usage,
  };

  // Only include landlord_id if it's provided
  if (
    newProperty.landlord_id !== undefined &&
    newProperty.landlord_id !== null
  ) {
    payload.landlord_id = newProperty.landlord_id;
  }

  const { data } = await AxiosInstance.post(
    `/v1/tenants/properties/new`,
    payload,
  );
  return data;
};

export const getProperty = async (id: any) => {
  const { data } = await AxiosInstance.get(`/v1/tenants/properties/${id}`, {});
  return data;
};

export const getOrganizationProperty = async (id: any) => {
  const { data } = await AxiosInstance.get(
    `/v1/tenants/properties/organization/${id}`,
    {},
  );
  return data;
};

export const deleteProperty = async (tenantId: any) => {
  await AxiosInstance.patch(`/v1/tenants/properties/disable/${tenantId}`);
};

export const updateProperty = async (
  beforeUpdateProperty: Property,
  propertyId: any,
  queryParams?: object,
) => {
  const { data } = await AxiosInstance.patch(
    `/v1/tenants/properties/update/${propertyId}`,
    beforeUpdateProperty,
    {
      params: queryParams,
    },
  );
  return data;
};
